import(/* webpackMode: "eager" */ "/usr/src/app/apps/portal-frontend/src/app/layout.tsx");
